module.exports = __webpack_public_path__ + "img/zhuangxiu_icon0.e8145592.png";